import React, { useState, useEffect, use } from "react";
import CreateRailwayProposal from '../proposal/CreateRailwayProposal';
// import ProposalDetails from "../../Pages/ProposalDetails";
import {
  MapPin, Building2, Home, Download, Send, Edit, Trash2, Plus, Search, FileText, Globe, Edit2, Filter, PlusCircle, X, ChevronDown, ChevronUp, Eye,
} from "lucide-react";
import apiService from "../../config";
import EditRailwayProposal from "../proposal/EditRailwayProposal";
import ViewRailwayProposal from '../proposal/ViewRailwayProposal';
import DownloadModal from "../../Components/Download/DownloadModal";
import { useLanguage } from '../../StoreContext/LanguageContext';

const RailwayProposal = ({ onClose, setSubComponent, setSelectedComponent, onBack }) => {
  // Location data states
  const [districts, setDistricts] = useState([]);
  const [availableTalukas, setAvailableTalukas] = useState([]);
  const [availableVillages, setAvailableVillages] = useState([]);
  const { language, translations } = useLanguage();
  // Filter states
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedTaluka, setSelectedTaluka] = useState("");
  const [selectedVillage, setSelectedVillage] = useState("");

  // Data states
  const [proposals, setProposals] = useState([]);
  const [showAddForm, setShowAddForm] = useState(false);
  const [showSamanvayModal, setShowSamanvayModal] = useState(false);
  const [showCollectorModal, setShowCollectorModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState("");
  const [remarks, setRemarks] = useState("Approved");
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [users, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [sending, setSending] = useState(false);
  const [filterMode, setFilterMode] = useState("all");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // ✅ NEW: Proposal selection states
  const [selectedProposals, setSelectedProposals] = useState(new Set());

  // Enhanced filter panel state
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Loading states
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [selectedProposalData, setSelectedProposalData] = useState(null);
  const [hoveredProposalId, setHoveredProposalId] = useState(null);
  const [hoveredStageName, setHoveredStageName] = useState("");
  const [hoveredStageDate, setHoveredStageDate] = useState("");
  const [hoveredStages, setHoveredStages] = useState([]);

  // Enhanced filter panel state
  const [showTrackingModal, setShowTrackingModal] = useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [selectedDocumentUrl, setSelectedDocumentUrl] = useState(null);
  const [documentType, setDocumentType] = useState("");
  // for download
  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  // Add these to your existing state variables
  const [showAlertModal, setShowAlertModal] = useState(false);
  const [showNamunaKModal, setShowNamunaKModal] = useState(false);
  const [namunaContext, setNamunaContext] = useState({ projectId: null, proposalId: null });

  const [alertConfig, setAlertConfig] = useState({
    title: '',
    message: '',
    type: 'success' // 'success', 'error', 'warning', 'info'
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showNamunaK, setShowNamunaK] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [viewMode, setViewMode] = useState(false);
  const [selectedProposalId, setSelectedProposalId] = useState(null);

  // View
  const [viewingProposal, setViewingProposal] = useState(null);

  // State to manage image modal
  const [imageModalUrl, setImageModalUrl] = useState(null);
  const { thumbnailUrl, fullImageUrl } = viewingProposal || {};

  const isImageUrl = (url) => {
    if (!url) return false;
    const ext = url.split('.').pop().toLowerCase();
    return ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(ext);
  };

  const openImageModal = (url) => {
    setImageModalUrl(url);
  };

  const closeImageModal = () => {
    setImageModalUrl(null);
  };

  <img
    src={thumbnailUrl}
    alt="Document Thumbnail"
    className="cursor-pointer"
    onClick={() => openImageModal(fullImageUrl)}
  />

  // const handleViewClick = async (proposal) => {
  //   setSelectedProposalId(proposal.acquisition_proposal_id);
  //   // Now fetch proposal details explicitly on click
  //   const projectId = selectedProject?.id || selectedProject?.project_id;
  //   if (!projectId) {
  //     showAlert("No project selected");
  //     return;
  //   }

  //   setLoading(true);
  //   setError(null);
  //   try {
  //     const result = await apiService.getProposalById(projectId, proposal.acquisition_proposal_id);
  //     if (result && result.status === 200) {
  //       const proposalsData = Array.isArray(result.data) ? result.data[0] : result.data; // if array, get first
  //       setViewingProposal(proposalsData);
  //     } else {
  //       setViewingProposal(null);
  //       showAlert("No data found for this proposal");
  //     }
  //   } catch (error) {
  //     setViewingProposal(null);
  //     showAlert(`Failed to load proposal details: ${error.message}`, '', 'error');
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Handler to close modal

  const closeModal = () => {
    setViewingProposal(null);
  };

  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'warning'
  });

  // Get user role and project data from localStorage
  const [userRole, setUserRole] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        return user.user_role || user.usr_role || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });

  const [currentLoginProposalId, setCurrentLoginProposalId] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        console.log("Current user proposal id:", user.default_proposal);

        return user.default_proposal || user.proposal_id || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });

  const [selectedProject, setSelectedProject] = useState(() => {
    try {
      const project = localStorage.getItem("selectedProject");
      return project ? JSON.parse(project) : null;
    } catch (error) {
      console.error("Error parsing project data:", error);
    }
    return null;
  });

  // ✅ MOVE ALL useEffect HOOKS BEFORE ANY CONDITIONAL RETURNS

  // Clear selections when proposals change
  useEffect(() => {
    setSelectedProposals(new Set());
  }, [proposals]);

  // Load districts on component mount
  useEffect(() => {
    loadDistricts();
  }, []);

  useEffect(() => {
    if (filterMode === "all") {
      fetchProposals();
    }
  }, [filterMode]);

  useEffect(() => {
    if (filterMode === "location" && isLocationSelectionComplete) {
      fetchProposals();
    } else if (filterMode === "location" && !isLocationSelectionComplete) {
      setProposals([]);
    }
  }, [filterMode, selectedDistrict, selectedTaluka, selectedVillage]);

  // Load talukas when district changes
  useEffect(() => {
    if (selectedDistrict) {
      loadTalukas();
    } else {
      setAvailableTalukas([]);
      setSelectedTaluka("");
      setSelectedVillage("");
      setAvailableVillages([]);
    }
  }, [selectedDistrict]);

  // Load villages when taluka changes
  useEffect(() => {
    if (selectedTaluka && selectedDistrict) {
      loadVillages();
    } else {
      setAvailableVillages([]);
      setSelectedVillage("");
    }
  }, [selectedTaluka, selectedDistrict]);

  // ✅ NOW AFTER ALL HOOKS, WE CAN HAVE CONDITIONAL LOGIC

  const isLocationSelectionComplete =
    selectedDistrict || selectedTaluka || selectedVillage;
  const canShowData =
    filterMode === "all" ||
    (filterMode === "location" && isLocationSelectionComplete);

  // Helper functions to show enhanced modals
  const showAlert = (title, message, type = 'info') => {
    setAlertConfig({ title, message, type });
    setShowAlertModal(true);
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  const handleViewDocument = (stage) => {
    if (stage.upload_path) {
      setSelectedDocumentUrl(stage.upload_path);
      setDocumentType(getDocumentType(stage.upload_path));
      setShowDocumentModal(true);
    } else {
      showAlert("No document available for this stage.");
    }
  };

  const getDocumentType = (url) => {
    if (!url) return "unknown";
    const extension = url.split(".").pop().toLowerCase();
    if (["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(extension)) {
      return "image";
    } else if (extension === "pdf") {
      return "pdf";
    } else {
      return "unknown";
    }
  };


  const handleTrackingClick = async (proposal) => {
    const projectId = selectedProject?.id || selectedProject?.project_id;
    const proposalId =
      proposal.proposal_id || proposal.id || proposal.acquisition_proposal_id;

    try {
      const response = await apiService.getTracking(projectId, proposalId);
      let data = [];

      if (Array.isArray(response)) {
        data = response;
      } else if (response && Array.isArray(response.data)) {
        data = response.data;
      }

      // Sort by date descending
      const sortedData = data.sort(
        (a, b) => new Date(b.cre_usr_dt) - new Date(a.cre_usr_dt)
      );
      setTrackingData(sortedData);

      // Show modal
      setShowTrackingModal(true);
    } catch (error) {
      console.error("Error fetching tracking data:", error);
      setTrackingData([]);
      showAlert("Failed to load tracking history.");
    }
  };

  // Helper functions for display names
  const getDistrictDisplayName = (district) => {
    return district.dist_name || `District ${district.dist_name}`;
  };

  const getTalukaDisplayName = (taluka) => {
    return taluka.taluka_name || `Taluka ${taluka.taluka_name}`;
  };

  const getVillageDisplayName = (village) => {
    return village.village_name || `Village ${village.village_name}`;
  };

  // ✅ NEW: Proposal selection handlers (row click)
  const handleSelectProposal = (proposalId, event) => {
    // Prevent selection when clicking on buttons
    if (event.target.tagName === "BUTTON" || event.target.closest("button")) {
      return;
    }

    const newSelected = new Set(selectedProposals);
    if (newSelected.has(proposalId)) {
      newSelected.delete(proposalId);
    } else {
      newSelected.add(proposalId);
    }
    setSelectedProposals(newSelected);
  };

  const handleSelectAll = () => {
    if (
      selectedProposals.size === filteredProposals.length &&
      filteredProposals.length > 0
    ) {
      setSelectedProposals(new Set());
    } else {
      const allIds = new Set(filteredProposals.map((p) => p.proposal_id));
      setSelectedProposals(allIds);
    }
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setSelectedTaluka([]);
    setSelectedVillage([]);
  };

  const handleTalukaChange = (e) => {
    setSelectedTaluka(e.target.value);
    setSelectedVillage([]);
  };

  const handleVillageChange = (e) => {
    setSelectedVillage(e.target.value);
  };

  const handleOpenNamunaK = () => {
    // Store location info in localStorage (keep this part)
    localStorage.setItem(
      'selectedLocationInfo',
      JSON.stringify({
        projectId: selectedProject?.id || selectedProject?.project_id,
        district: selectedDistrict || '',
        taluka: selectedTaluka || '',
        village: selectedVillage || ''
      })
    );

    // Set the context for NamunaK component
    setNamunaContext({
      projectId: selectedProject?.id || selectedProject?.project_id,
      // proposalId: null // or set specific proposal ID if needed
    });

    setSelectedComponent("CreateRailwayProposal");
    setSubComponent(CreateRailwayProposal);
  };

  const handleCloseNamunaK = () => {
    setShowNamunaKModal(false);
  };

  const handleEditClick = (proposal) => {
    setSelectedProposalId(proposal.acquisition_proposal_id);
    setEditMode(true);
  };

  // Handle back from edit
  const handleBackFromEdit = () => {
    setEditMode(false);
    setSelectedProposalId(null);
    // Optionally refresh the proposals list
    // loadProposals();
  };

  const handleViewClick = (proposal) => {
    setSelectedProposalId(proposal.acquisition_proposal_id);
    setViewMode(true);
  };

  const handleBackFromView = () => {
    setViewMode(false);
    setSelectedProposalId(null);
    // Optionally refresh the proposals list
    // loadProposals();
  };

  const fetchProposals = async () => {
    const projectId = selectedProject?.id || selectedProject?.project_id;

    if (!projectId) {
      console.warn("No project selected, cannot fetch proposals.");
      setProposals([]);
      return;
    }

    if (filterMode === "location" && !selectedDistrict) {
      setProposals([]);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      console.log("📋 Fetching proposals for project:", projectId);

      const result = await apiService.getRailwayProposal(projectId);
      console.log("📋 Proposals API result:", result);

      if (result && result.status === 200) {
        const proposalsData = Array.isArray(result.data) ? result.data : [];
        setProposals(proposalsData);
        console.log("📋 Set proposals data:", proposalsData);
      } else {
        console.warn("📋 Unexpected API response structure:", result);
        setProposals([]);
      }
    } catch (error) {
      console.error("📋 Error fetching proposals:", error);
      setProposals([]);
      setError(`Failed to load proposals: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const refreshProposals = () => {
    console.log("📋 Refreshing proposals...");
    fetchProposals();
  };

  // Load districts
  const loadDistricts = async () => {
    try {
      setLoadingDistricts(true);
      setError(null);
      const response = await apiService.getDistricts();
      console.log("Districts response:", response);

      const districtsData = response.data || response || [];
      const districtsArray = Array.isArray(districtsData) ? districtsData : [];
      setDistricts(districtsArray);
    } catch (error) {
      console.error("Error loading districts:", error);
      setDistricts([]);
      setError("Failed to load districts");
    } finally {
      setLoadingDistricts(false);
    }
  };

  // Load talukas
  const loadTalukas = async () => {
    try {
      setLoadingTalukas(true);
      setError(null);
      setAvailableTalukas([]);

      const selectedDistrictObj = districts.find(
        (d) => d.name === selectedDistrict || d.dist_name === selectedDistrict
      );

      if (!selectedDistrictObj) {
        console.warn("Selected district object not found:", selectedDistrict);
        return;
      }

      const distNo = selectedDistrictObj.dist_name;
      console.log("Loading talukas for district:", distNo);

      const response = await apiService.getTalukas(distNo);
      console.log("Talukas response:", response);

      const talukasData = response.data || response || [];
      const talukasArray = Array.isArray(talukasData) ? talukasData : [];
      setAvailableTalukas(talukasArray);
    } catch (error) {
      console.error("Error loading talukas:", error);
      setAvailableTalukas([]);
      setError("Failed to load talukas");
    } finally {
      setLoadingTalukas(false);
    }
  };

  // Load villages
  const loadVillages = async () => {
    try {
      setLoadingVillages(true);
      setError(null);
      setAvailableVillages([]);

      const selectedDistrictObj = districts.find(
        (d) => d.name === selectedDistrict || d.dist_name === selectedDistrict
      );
      const selectedTalukaObj = availableTalukas.find(
        (t) =>
          t.name === selectedTaluka ||
          t.taluka_name === selectedTaluka ||
          t.tehsil_name === selectedTaluka
      );

      if (!selectedDistrictObj || !selectedTalukaObj) {
        console.warn("District or Taluka object not found:", {
          district: selectedDistrict,
          taluka: selectedTaluka,
        });
        return;
      }

      const distNo = selectedDistrictObj.dist_name;
      const tehsilNo = selectedTalukaObj.taluka_name;

      console.log("Loading villages for:", { distNo, tehsilNo });

      const response = await apiService.getVillages(distNo, tehsilNo);
      console.log("Villages response:", response);

      const villagesData = response.data || response || [];
      const villagesArray = Array.isArray(villagesData) ? villagesData : [];
      setAvailableVillages(villagesArray);
    } catch (error) {
      console.error("Error loading villages:", error);
      setAvailableVillages([]);
      setError("Failed to load villages");
    } finally {
      setLoadingVillages(false);
    }
  };

  const handleDownload = () => {
    setDownloadModalOpen(true);
  };

  const getColumnsForDownload = () => {
    return [
      { header: "Proposal ID", value: "acquisition_proposal_id" },
      { header: "Proposal No", value: "acquisition_proposal_no" },
      { header: "Date", value: "acquisition_proposal_date" },
      { header: "Area", value: "acquisition_area" },
      { header: "Area", value: "is_exemption_applicabl" },
      { header: "Status", value: "isactive" },
    ];
  };

  const getDataForDownload = () => {
    return filteredProposals.map((landholding, index) => ({
      ...landholding,
      index: index + 1,
      acquisition_proposal_date: formatDateToDDMMYYYY(
        landholding.acquisition_proposal_date
      ),
      status: landholding.status ? "Active" : "Inactive",
    }));
  };

  const handleAddProposal = () => {
    setShowAddForm(true);
  };

  // ✅ UPDATED: Handle Send to Samanvay with selected proposals check
  const handleSendToSamanvay = () => {
    if (selectedProposals.size === 0) {
      showAlert("Please select at least one proposal to send to Samanvay");
      return;
    }
    setShowSamanvayModal(true);
    fetchSamanvayUsers();
  };

  // ✅ UPDATED: Handle Send to Collector with selected proposals check
  const handleSendToCollector = () => {
    if (selectedProposals.size === 0) {
      showAlert("Please select at least one proposal to send to Collector");
      return;
    }
    setShowCollectorModal(true);
    fetchCollectorUsers();
  };

  // ✅ UPDATED: Handle Samanvay Submit with selected proposals
  const handleSamanvaySubmit = async () => {
    if (!selectedUser || !selectedDocument) {
      showAlert("Please select a user and upload a document");
      return;
    }

    if (selectedProposals.size === 0) {
      showAlert("No proposals selected");
      return;
    }

    const projectId = selectedProject?.id || selectedProject?.project_id;
    const selectedProposalIds = Array.from(selectedProposals);

    setSending(true);
    try {
      const formData = new FormData();
      formData.append("project_id", projectId);
      formData.append("remarks", remarks);
      formData.append("usr_id", selectedUser);
      formData.append("document", selectedDocument);
      formData.append("proposal_ids", JSON.stringify(selectedProposalIds));
      formData.append("district", selectedDistrict);
      formData.append("taluka", selectedTaluka);
      formData.append("village", selectedVillage);

      const result = await apiService.postTracking(formData, "Samanvay");

      console.log("Send to Samanvay response:", result);

      if (result.status === 200) {
        showAlert(
          `Successfully sent ${selectedProposalIds.length} proposal(s) to Samanvay!`
        );
        setShowSamanvayModal(false);
        setSelectedUser("");
        setRemarks("Approved");
        setSelectedDocument(null);
        setSelectedProposals(new Set()); // Clear selections
      } else {
        showAlert("Failed to send to Samanvay. Please try again.");
      }
    } catch (error) {
      console.error("Error sending to Samanvay:", error);
      showAlert("Error while sending to Samanvay. Please try again.");
    } finally {
      setSending(false);
    }
  };

  // ✅ UPDATED: Handle Collector Submit with selected proposals
  const handleCollectorSubmit = async () => {
    if (!selectedUser || !selectedDocument) {
      showAlert("Please select a user and upload a document");
      return;
    }

    if (selectedProposals.size === 0) {
      showAlert("No proposals selected");
      return;
    }

    const projectId = selectedProject?.id || selectedProject?.project_id;
    const selectedProposalIds = Array.from(selectedProposals);

    setSending(true);
    try {
      const formData = new FormData();
      formData.append("project_id", projectId);
      formData.append("remarks", remarks);
      formData.append("usr_id", selectedUser);
      formData.append("document", selectedDocument);
      formData.append("proposal_ids", JSON.stringify(selectedProposalIds)); // Add selected proposal IDs

      const result = await apiService.postTracking(formData, "Collector");

      console.log("Send to Collector response:", result);

      if (result.status === 200) {
        showAlert(
          `Successfully sent ${selectedProposalIds.length} proposal(s) to Collector!`
        );
        setShowCollectorModal(false);
        setSelectedUser("");
        setRemarks("Approved");
        setSelectedDocument(null);
        setSelectedProposals(new Set()); // Clear selections
      } else {
        showAlert("Failed to send to Collector. Please try again.");
      }
    } catch (error) {
      console.error("Error sending to Collector:", error);
      showAlert("Error while sending to Collector. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const handleDocumentSelect = (e) => {
    const file = e.target.files[0];
    setSelectedDocument(file);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  // Filter proposals based on search term
  const filteredProposals = proposals.filter((proposal) => {
    if (!searchTerm) return true;

    const searchFields = [
      "acquisition_proposal_no",
      "propsal_description",
      "acquisition_agency",
      "acquisition_purpose",
      "village_name",
      "taluka_name",
      "dist_name",
    ];

    const searchTermLower = searchTerm.toLowerCase();

    return searchFields.some((field) => {
      const value = proposal[field];
      return value && String(value).toLowerCase().includes(searchTermLower);
    });
  });

  const handleSection11Report = (proposal) => {
    console.log("📊 Generating Section-11 Report for proposal:", proposal);
    showAlert(
      `Generating Section-11 Report for: ${proposal.acquisition_proposal_no || "Unknown Proposal"
      }`
    );
  };

  const formatDateToDDMMYYYY = (dateString) => {
    if (!dateString) return "N/A";

    try {
      const date = new Date(dateString);

      // Check if date is valid
      if (isNaN(date.getTime())) return "Invalid Date";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    } catch (error) {
      return "Invalid Date";
    }
  };

  const handleVerifyProposal = (proposal) => {
    console.log("📋 Verifying proposal:", proposal);
    showAlert(`Verifying proposal: ${proposal.acquisition_proposal_no}`);
  };

  const handleCollectorApproval = (proposal) => {
    console.log("📋 Approving proposal:", proposal);
    showAlert(`Approving proposal: ${proposal.acquisition_proposal_no}`);
  };

  const fetchSamanvayUsers = async () => {
    setLoadingUsers(true);
    try {
      const result = await apiService.getAllUserRole(6);
      console.log("Samanvay users response:", result);
      if (result.status === 200 && result.data) {
        setUsers(Array.isArray(result.data) ? result.data : []);
      }
    } catch (error) {
      console.error("Error fetching Samanvay users:", error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchCollectorUsers = async () => {
    setLoadingUsers(true);
    try {
      const result = await apiService.getAllUserRole(5);
      console.log("Collector users response:", result);
      if (result.status === 200 && result.data) {
        setUsers(Array.isArray(result.data) ? result.data : []);
      }
    } catch (error) {
      console.error("Error fetching Collector users:", error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const getFilteredProposals = () => {
    if (userRole === 3 && currentLoginProposalId) {
      return filteredProposals.filter(proposal =>
        proposal.acquisition_proposal_id === currentLoginProposalId ||
        proposal.proposal_id === currentLoginProposalId
      );
    }
    return filteredProposals; // Return all data for other roles
  };

  // Use this in your JSX
  const displayProposals = getFilteredProposals();

  // If in edit mode, show EditProposal component
  if (editMode && selectedProposalId) {
    return (
      <EditRailwayProposal
        proposalId={selectedProposalId}
        projectName={selectedProject.project_name}
        projectId={selectedProject.id}
        onBack={handleBackFromEdit}
      />
    );
  }
  if (viewMode && selectedProposalId && selectedProject.id) {
    return (
      <ViewRailwayProposal
        proposalId={selectedProposalId}
        projectId={selectedProject.id}
        projectName={selectedProject.project_name}
        onBack={handleBackFromView}
      />
    );
  }

  const renderProposalTable = () => (
    <div className="mt-3">
      {loading && (
        <div className="flex justify-center items-center h-80">
          <div className="text-center">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div
                className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0"
                style={{
                  animationDuration: "1.5s",
                  animationDirection: "reverse",
                }}
              ></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <MapPin className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">{translations[language].loadingProposals}</p>
          </div>
        </div>
      )}

      {!loading && filteredProposals.length > 0 && (
        <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
          {/* Custom scrollbar container */}
          <div
            className="overflow-x-auto custom-scrollbar"
            style={{
              scrollbarWidth: 'thin',
              scrollbarColor: '#cbd5e1 #f1f5f9'
            }}
          >
            <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          height: 12px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f5f9;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(45deg, #cbd5e1, #94a3b8);
          border-radius: 10px;
          border: 2px solid #f1f5f9;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(45deg, #94a3b8, #64748b);
        }
      `}</style>

            <table className="min-w-full table-auto">
              <thead>
                <tr className="bg-blue-200 border-b-2 border-blue-100">
                  <th className="px-6 py-4 text-center text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    {translations[language].action}
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].proposalNo}</span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].date}</span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].TotalArea}</span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].AcquiredArea}</span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].publish}</span>
                    </div>
                  </th>
                  <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>{translations[language].status}</span>
                    </div>
                  </th>
                  {/* <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                    <div className="flex items-center space-x-2">
                      <span>Location</span>
                    </div>
                  </th> */}

                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-100">
                {displayProposals.map((proposal, index) => (
                  <tr
                    key={proposal.acquisition_proposal_id}
                    className={`hover:bg-blue-50 transition-all duration-200 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'
                      }`}
                  >
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => handleViewClick(proposal)}
                          className="group relative inline-flex items-center px-3 py-2 border border-blue-200 rounded-lg text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 hover:border-blue-300 transition-all duration-200 hover:shadow-md"
                        >
                          <Eye size={14} />
                        </button>
                        {/* {userRole === 18 && ( */}
                        {/* Data Entry */}
                        {(userRole === 18 || userRole === 14) && (
                          <button
                            onClick={() => handleEditClick(proposal)}
                            className="group relative inline-flex items-center px-3 py-2 border border-indigo-200 rounded-lg text-xs font-medium text-indigo-700 bg-indigo-50 hover:bg-indigo-100 hover:border-indigo-300 transition-all duration-200 hover:shadow-md"
                          >
                            <Edit2 size={16} />
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-semibold text-gray-900">
                        {proposal.acquisition_proposal_no}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-700">
                        {formatDateToDDMMYYYY(proposal.acquisition_proposal_date)}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-700">
                        {proposal.total_area}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-700">
                        {proposal.aquired_area}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-700">
                        {proposal.propsal_publication_no &&
                          proposal.propsal_publication_date
                          ? "Published"
                          : "Not Published"}
                      </div>
                    </td>
                    {/* Status */}
                    <td className="px-6 py-4 whitespace-nowrap">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          handleTrackingClick(proposal);
                        }}
                        className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium shadow-sm transition
  ${proposal.isactive === true || proposal.isactive === 1
                            ? "bg-green-100 text-green-800 border border-green-200 hover:bg-green-200 hover:text-green-900 hover:scale-105"
                            : "bg-yellow-100 text-yellow-800 border border-yellow-200 hover:bg-yellow-300 hover:text-yellow-800 hover:scale-105"
                          }
`}
                      >
                        <span
                          className={`w-2 h-2 rounded-full mr-2 ${proposal.isactive === true ||
                            proposal.isactive === 1
                            ? "bg-green-500"
                            : "bg-yellow-500"
                            }`}
                        />
                        {proposal.isactive === true ||
                          proposal.isactive === 1
                          ? "Active"
                          : "Pending"}
                      </button>
                    </td>
                    {/* <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-gray-700">
                        गा.{proposal.village_name || " "}, ता.{proposal.taluka_name || " "}, जि.{proposal.dist_name || " "}
                      </div>
                    </td> */}

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* {viewingProposal && (
       
      )} */}

      {/* Image Modal */}


      {!loading && filteredProposals.length === 0 && (
        <div className="text-center py-12">
          <FileText className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">{translations[language].noProposalsFound}</p>
        </div>
      )}
    </div>
  );

  return (
    <div className="p-4 bg-gray-50 min-h-screen">
      {/* Header Section */}
      {/* {userRole === 18 && ( */}
      {/* Data Entry */}
      {(userRole === 18 || userRole === 14) && (

        <div className="relative z-4 ">
          <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
            {/* Action Buttons */}
            <div className="flex flex-wrap gap-3">
              {/* <button
                onClick={() => setShowFilterPanel(!showFilterPanel)}
                className="px-4 py-2 bg-gradient-to-r from-orange-700 to-orange-500 hover:from-orange-700 hover:to-orange-900 text-white rounded-lg flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-gray-200 hover:shadow-gray-300 group"
              >
                <Filter className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-medium">Filters</span>
                {showFilterPanel ? (
                  <ChevronUp className="h-4 w-4 transition-transform duration-300" />
                ) : (
                  <ChevronDown className="h-4 w-4 transition-transform duration-300" />
                )}
              </button> */}

              <>

                <button
                  onClick={() => setSubComponent("CreateRailwayProposal")}
                  className="px-5 py-3 text-sm bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-blue-200 hover:shadow-blue-300 group"
                >
                  {translations[language].addProposal}
                </button>

                {showNamunaKModal && (
                  <CreateRailwayProposal
                    isOpen={showNamunaKModal}
                    onClose={handleCloseNamunaK}
                  />
                )}
              </>

              {/* {filteredProposals.length > 0 && (
                <button
                  onClick={handleDownload}
                  className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group"
                >
                  <Download className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                  <span className="font-medium">Download</span>
                </button>
              )} */}

            </div>

          </div>
        </div>
      )}
      {/* Collapsible Filter Panel */}
      {showFilterPanel && (
        <div className="relative z-10 border-t border-gray-200 bg-gray-50/50 backdrop-blur-sm">
          <div className="p-6 space-y-6">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              <div className="mb-4 flex items-center justify-between">
                <div className="flex items-center space-x-1 bg-gray-100 rounded-lg p-1">
                  <button
                    onClick={() => setFilterMode("all")}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === "all"
                      ? "bg-white text-blue-600 shadow-sm"
                      : "text-gray-600 hover:text-gray-800"
                      }`}
                  >
                    <Globe className="h-4 w-4" />
                    <span>{translations[language].allRecords}</span>
                  </button>
                  <button
                    onClick={() => setFilterMode("location")}
                    className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === "location"
                      ? "bg-white text-blue-600 shadow-sm"
                      : "text-gray-600 hover:text-gray-800"
                      }`}
                  >
                    <MapPin className="h-4 w-4" />
                    <span>{translations[language].filterByLocation}</span>
                  </button>
                </div>
              </div>

              <div className="flex-1 max-w-md">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                  <input
                    type="text"
                    placeholder={translations[language].searchProposals}
                    value={searchTerm}
                    onChange={handleSearch}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>
            </div>

            {filterMode === "location" && (
              <div className="space-y-4">
                <div className="flex items-center">
                  <MapPin className="h-5 w-5 text-blue-600 mr-2" />
                  <h3 className="text-lg font-semibold text-gray-800">
                    {translations[language].selectLocation}
                  </h3>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].district} <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={selectedDistrict}
                      onChange={handleDistrictChange}
                      disabled={loadingDistricts}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">
                        {loadingDistricts
                          ? <span>{translations[language].loadingDistricts}</span>
                          : <span>{translations[language].selectDistrict}</span>}
                      </option>
                      {districts.map((district, index) => (
                        <option
                          key={district.dist_name || index}
                          value={district.dist_name}
                        >
                          {getDistrictDisplayName(district)}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].taluka} <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={selectedTaluka}
                      onChange={handleTalukaChange}
                      disabled={!selectedDistrict || loadingTalukas}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">
                        {loadingTalukas
                          ? <span>{translations[language].loadingTalukas}</span>
                          : <span>{translations[language].selectTaluka}</span>}
                      </option>
                      {availableTalukas.map((taluka, index) => (
                        <option
                          key={taluka.taluka_name || index}
                          value={getTalukaDisplayName(taluka)}
                        >
                          {getTalukaDisplayName(taluka)}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {translations[language].village} <span className="text-red-500">*</span>
                    </label>
                    <select
                      value={selectedVillage}
                      onChange={handleVillageChange}
                      disabled={!selectedTaluka || loadingVillages}
                      className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:bg-gray-100 disabled:cursor-not-allowed"
                    >
                      <option value="">
                        {loadingVillages
                          ? <span>{translations[language].loadingVillages}</span>
                          : <span>{translations[language].selectVillage}</span>}
                      </option>
                      {availableVillages.map((village, index) => (
                        <option
                          key={village.village_name || index}
                          value={getVillageDisplayName(village)}
                        >
                          {getVillageDisplayName(village)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                {!isLocationSelectionComplete && (
                  <p className="text-sm text-amber-600">
                    {translations[language].selectDistrictTalukaVillage}
                  </p>
                )}
                {selectedDistrict && selectedTaluka && selectedVillage && (
                  <p className="text-sm text-green-600">
                    📍 {translations[language].locationSelected}:{selectedDistrict} {selectedTaluka}{" "}
                    {selectedVillage}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      {showNamunaK && (
        <CreateRailwayProposal
          projectId={selectedProject?.id || selectedProject?.project_id}
          district={selectedDistrict}
          taluka={selectedTaluka}
          village={selectedVillage}
          onClose={() => setShowNamunaK(false)}
        />
      )}


      {error && (
        <div className="mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
          <div className="flex items-center justify-between">
            <span>{error}</span>
            <button
              onClick={() => setError(null)}
              className="text-red-700 hover:text-red-900"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        </div>
      )}

      {canShowData && renderProposalTable()}

      {filterMode === "location" && !isLocationSelectionComplete && (
        <div className="text-center py-12">
          <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <p className="text-gray-500 text-lg">
            {translations[language].viewDataPrompt}
          </p>
        </div>
      )}

      {/* ProposalDetails Modal */}
      {/* {showAddForm && (
        <ProposalDetails
          selectedDistrict={selectedDistrict}
          selectedTaluka={selectedTaluka}
          selectedVillage={selectedVillage}
          districts={districts}
          availableTalukas={availableTalukas}
          availableVillages={availableVillages}
          onSubmit={(data) => {
            // console.log('📋 Proposal submitted:', data);
            showAlert("✅ Proposal submitted successfully!");
            setShowAddForm(false);
            // refreshProposals();
          }}
          onClose={() => setShowAddForm(false)}
        />
      )} */}

      {showEditForm && selectedProposalData && (
        <EditRailwayProposal
          proposalData={selectedProposalData}
          onClose={() => {
            setShowEditForm(false);
            setSelectedProposalData(null);
          }}
          onUpdated={() => {
            setShowEditForm(false);
            setSelectedProposalData(null);
            // refreshProposals(); // Reload proposals
          }}
        />
      )}

      {showTrackingModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-lg shadow-2xl max-h-[85vh] overflow-hidden">
            {/* Header */}
            <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  <svg
                    className="w-4 h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                    />
                  </svg>
                </div>
                <h2 className="text-lg font-semibold text-white">
                  {translations[language].trackingHistory}
                </h2>
              </div>
              <button
                onClick={() => setShowTrackingModal(false)}
                className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors"
              >
                <X className="h-4 w-4 text-white" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto max-h-[calc(85vh-80px)]">
              {trackingData.length > 0 ? (
                <div className="space-y-4">
                  {trackingData.map((stage, index) => (
                    <div key={stage.tracking_id} className="relative">
                      {/* Stage Card */}
                      <div className="bg-gray-50 rounded-xl p-4 hover:bg-gray-100 transition-colors">
                        <div className="flex items-start space-x-4">
                          {/* Timeline Dot */}
                          <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                            <svg
                              className="w-4 h-4 text-white"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M5 10l7-7m0 0l7 7m-7-7v18"
                              />
                            </svg>
                          </div>

                          {/* Stage Info */}
                          <div className="flex-1 min-w-0">
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <h3 className="font-semibold text-gray-900 text-sm mb-1">
                                  {stage.to_stage_name}
                                </h3>

                                {/* Stage Flow */}
                                {stage.from_stage_name && (
                                  <div className="flex items-center text-xs text-gray-500 mb-2">
                                    <span className="bg-gray-200 px-2 py-1 rounded text-xs">
                                      {stage.from_stage_name}
                                    </span>
                                    <svg
                                      className="w-3 h-3 mx-1"
                                      fill="none"
                                      stroke="currentColor"
                                      viewBox="0 0 24 24"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M9 5l7 7-7 7"
                                      />
                                    </svg>
                                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs">
                                      {stage.to_stage_name}
                                    </span>
                                  </div>
                                )}

                                {/* Date */}
                                <div className="flex items-center text-xs text-gray-500 mb-2">
                                  <svg
                                    className="w-3 h-3 mr-1"
                                    fill="none"
                                    stroke="currentColor"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                  </svg>
                                  {new Date(stage.cre_usr_dt).toLocaleString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                      hour: "2-digit",
                                      minute: "2-digit",
                                      hour12: true,
                                    }
                                  )}
                                </div>

                                {/* Remarks */}
                                {stage.remarks && (
                                  <div className="bg-white rounded-lg p-2 mt-2 border border-gray-200">
                                    <div className="flex items-start">
                                      <svg
                                        className="w-3 h-3 text-gray-400 mr-1 mt-0.5 flex-shrink-0"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                          strokeWidth={2}
                                          d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"
                                        />
                                      </svg>
                                      <div className="text-xs text-gray-600">
                                        <span className="font-medium text-gray-700">
                                          {translations[language].Remarks}:
                                        </span>{" "}
                                        {stage.remarks}
                                      </div>
                                    </div>
                                  </div>
                                )}
                              </div>

                              {/* Action Button */}
                              <div className="ml-3 flex-shrink-0">
                                {stage.upload_path ? (
                                  <button
                                    onClick={() => handleViewDocument(stage)}
                                    className="inline-flex items-center mt-6 px-3 py-1 text-xs font-medium bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors"
                                  >
                                    <Eye className="h-3 w-3 mr-1" />
                                    {translations[language].document}
                                  </button>
                                ) : (
                                  <textview className="inline-flex items-center mt-6 px-3 py-1 text-xs font-medium bg-gray-400  text-white rounded-lg transition-colors">
                                    {translations[language].noDocument}
                                  </textview>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <svg
                      className="w-8 h-8 text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                      />
                    </svg>
                  </div>
                  <h3 className="text-lg font-medium text-gray-900 mb-2">
                    {translations[language].noTrackingHistory}
                  </h3>
                  <p className="text-gray-500 text-sm">
                    {translations[language].proposalNotProcessed}
                  </p>
                </div>
              )}
            </div>

            {/* Footer */}
            {trackingData.length > 0 && (
              <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
                <div className="flex items-center justify-between text-xs text-gray-600">
                  <span className="font-medium">
                    {trackingData.length} {translations[language].stage}
                    {trackingData.length !== 1 ? "s" : ""} {translations[language].completed}
                  </span>
                  <span>
                    {translations[language].lastUpdated}:{" "}
                    {new Date(trackingData[0]?.cre_usr_dt).toLocaleDateString()}
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
            alertConfig.type === 'warning' ? 'border-yellow-500' :
              alertConfig.type === 'info' ? 'border-blue-500' :
                'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                  alertConfig.type === 'warning' ? 'bg-yellow-100' :
                    alertConfig.type === 'info' ? 'bg-blue-100' :
                      'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                    alertConfig.type === 'warning' ? 'text-yellow-600' :
                      alertConfig.type === 'info' ? 'text-blue-600' :
                        'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                {confirmConfig.type === 'danger' ? '⚠' :
                  confirmConfig.type === 'warning' ? '⚠' : '?'}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                {confirmConfig.title}
              </h3>

              <p className="text-gray-600 text-sm mb-6 text-center">
                {confirmConfig.message}
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onCancel) confirmConfig.onCancel();
                  }}
                  className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                  }}
                  className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                    confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                      'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {translations[language].confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showDocumentModal && (
        <div className="fixed inset-0 bg-blue/80 backdrop-blur-sm flex justify-center items-center z-[60] p-4">
          <div className="bg-white rounded-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden shadow-2xl border border-blue-200">
            {/* Document Modal Header */}
            <div className="bg-gradient-to-r from-blue-700 to-blue-900 px-6 py-4 flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
                  {documentType === "image" ? (
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                  ) : (
                    <svg
                      className="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      />
                    </svg>
                  )}
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-white">
                    {translations[language].documentViewer}
                  </h3>
                  <p className="text-gray-300 text-sm">
                    {documentType === "image"
                      ? "Image Document"
                      : documentType === "pdf"
                        ? "PDF Document"
                        : "Document"}
                  </p>
                </div>
              </div>
              <div className="flex items-center space-x-2">
                <a
                  href={selectedDocumentUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-3 py-2 bg-white/20 hover:bg-white/30 text-white rounded-lg transition-colors duration-200 text-sm font-medium"
                >
                  <svg
                    className="w-4 h-4 inline mr-1"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                    />
                  </svg>
                  {translations[language].openOriginal}
                </a>
                <button
                  onClick={() => setShowDocumentModal(false)}
                  className="w-8 h-8 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-all duration-200 group"
                >
                  <X className="h-4 w-4 text-white group-hover:scale-110 transition-transform" />
                </button>
              </div>
            </div>

            {/* Document Content */}
            <div
              className="bg-gray-100 flex items-center justify-center"
              style={{ height: "calc(90vh - 80px)" }}
            >
              {documentType === "image" ? (
                <div className="w-full h-full flex items-center justify-center p-4">
                  <img
                    src={selectedDocumentUrl}
                    alt="Document"
                    className="max-w-full max-h-full object-contain rounded-lg shadow-lg"
                    onError={(e) => {
                      e.target.style.display = "none";
                      e.target.nextSibling.style.display = "flex";
                    }}
                  />
                  <div className="hidden flex-col items-center justify-center text-gray-500">
                    <svg
                      className="w-16 h-16 mb-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
                      />
                    </svg>
                    <p className="text-lg font-medium">{translations[language].failedToLoadImage}</p>
                  </div>
                </div>
              ) : documentType === "pdf" ? (
                <div className="w-full h-full">
                  <iframe
                    src={selectedDocumentUrl}
                    className="w-full h-full border-0"
                    title="PDF Document"
                  />
                </div>
              ) : (
                <div className="flex flex-col items-center justify-center text-gray-500 p-8">
                  <svg
                    className="w-16 h-16 mb-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    />
                  </svg>
                  <p className="text-lg font-medium mb-2">
                    {translations[language].previewNotAvailable}
                  </p>
                  <p className="text-sm text-gray-400 mb-4">
                    {translations[language].cannotPreviewInBrowser}
                  </p>
                  <a
                    href={selectedDocumentUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors duration-200 font-medium"
                  >
                    {translations[language].downloadAndOpen}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Download Modal */}
      <DownloadModal
        isOpen={downloadModalOpen}
        onClose={() => setDownloadModalOpen(false)}
        title={translations[language].ProposalManagement}
        data={getDataForDownload()}
        columns={getColumnsForDownload()}
        isLoading={downloadLoading}
        setIsLoading={setDownloadLoading}
        screenName="Proposal Management"
      />
      {
        showNamunaKModal && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-6xl max-h-[90vh] overflow-hidden">
              <div className="p-4 border-b border-gray-200 flex justify-between items-center">
                <h2 className="text-xl font-semibold"> {translations[language].namunak}</h2>
                <button
                  onClick={handleCloseNamunaK}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>
              <div className="p-4 overflow-y-auto" style={{ maxHeight: 'calc(90vh - 80px)' }}>
                <CreateRailwayProposal
                  projectId={namunaContext.projectId}
                  proposalId={namunaContext.proposalId}
                  district={selectedDistrict}
                  taluka={selectedTaluka}
                  village={selectedVillage}
                  onClose={handleCloseNamunaK}
                  isOpen={showNamunaKModal}
                />
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default RailwayProposal;